module.exports = __webpack_public_path__ + "static/media/aivr-purple.8ef79072.svg";